export const PORTAL_TITLE = "Capital One Travel Portal";
export const CAR_SEARCH_TITLE = "Search a car rental";
export const SELECT_A_CAR_TITLE = "Select a car rental";
export const REVIEW_CAR_TITLE = "Review car rental";
export const CAR_CHECKOUT_TITLE = "Complete Car Booking";
export const CAR_CONFIRMATION_TITLE = "Booking Confirmation";
